export enum QueryKeyEnum {
  SERVERS = 'SERVERS',
  TERMINALS = 'TERMINALS',
  CARDS = 'CARDS',
  CARD_HISTORY = 'CARD_HISTORY',
  CARD_DETAILS = 'CARD_DETAILS',
  CARD_SEARCH = 'CARD_SEARCH',
  OWNERS = 'OWNERS',
  OWNERS_SEARCH = 'OWNERS_SEARCH',
  OWNER_DETAILS = 'OWNER_DETAILS',
  OWNER_HISTORY = 'OWNER_HISTORY',
  OWNER_HISTORY_PHOTO_OLD = 'OWNER_HISTORY_PHOTO_OLD',
  OWNER_HISTORY_PHOTO_NEW = 'OWNER_HISTORY_PHOTO_NEW',
  RANDOM_CONTROL_OWNERS = 'RANDOM_CONTROL_OWNERS',
  EVENTS = 'EVENTS',
  CARDS_WITH_OWNERS = 'CARDS_WITH_OWNERS',
  POSITIONS = 'POSITIONS',
  POSITIONS_SEARCH = 'POSITIONS_SEARCH',
  EVENTS_EXPORT_FORMAT = 'EVENTS_EXPORT_FORMAT',
  EVENT_EXPORT_FORMAT_DETAILS = 'EVENT_EXPORT_FORMAT_DETAILS',
  EVENTS_EXPORT_FORMAT_CONFIG = 'EVENTS_EXPORT_FORMAT_CONFIG',
  ORGANIZATIONS = 'ORGANIZATIONS',
  ORGANIZATIONS_FOR_USER = 'ORGANIZATIONS_FOR_USER',
  ORGANIZATIONS_SEARCH = 'ORGANIZATIONS_SEARCH',
  STREFY = 'STREFY',
  MONITORING_OBECNOSCI = 'MONITORING_OBECNOSCI',
  OBECNOSC_STREFY = 'OBECNOSC_STREFY',
  PRESENT_OWNERS_REPORT_STREFY = 'PRESENT_OWNERS_REPORT_STREFY',
  OBECNOSC_POSIADACZE = 'OBECNOSC_POSIADACZE',
  PRZEJSCIE_SERWERY = 'PRZEJSCIE_SERWERY',
  PRZEJSCIA = 'PRZEJSCIA',
  PRZEJSCIE_DOSTEPNE_TKD = 'PRZEJSCIE_DOSTEPNE_TKD',
  OWNER_PHOTO = 'OWNER_PHOTO',
  USERS = 'USERS',
  OWNER_PERMISSIONS_EFFECTIVE_SERVERS = 'OWNER_PERMISSIONS_EFFECTIVE_SERVERS',
  OWNER_PERMISSIONS_INDIVIDUAL_SERVERS = 'OWNER_PERMISSIONS_INDIVIDUAL_SERVERS',
  OWNER_PERMISSIONS_INDIVIDUAL = 'OWNER_PERMISSIONS_INDIVIDUAL',
  OWNER_PERMISSIONS_EFFECTIVE = 'OWNER_PERMISSIONS_EFFECTIVE',
  OWNER_GROUPS = 'OWNER_GROUPS',
  OWNER_GROUPS_SEARCH = 'OWNER_GROUPS_SEARCH',
  GROUPS = 'GROUPS',
  GROUP_HISTORY = 'GROUP_HISTORY',
  GROUP_PERMISSIONS_HISTORY = 'GROUP_PERMISSIONS_HISTORY',
  GROUP_DETAILS = 'GROUP_DETAILS',
  GROUPS_SEARCH = 'GROUPS_SEARCH',
  GROUP_TERMINALS_PERMISSIONS_SERVERS = 'GROUP_TERMINALS_PERMISSIONS_SERVERS',
  GROUP_TERMINALS_PERMISSIONS = 'GROUP_TERMINALS_PERMISSIONS',
  GROUP_GLC_PERMISSIONS_SERVERS = 'GROUP_GLC_PERMISSIONS_SERVERS',
  GROUP_GLC_PERMISSIONS = 'GROUP_GLC_PERMISSIONS',
  GROUP_ASSIGNED_OWNERS = 'GROUP_ASSIGNED_OWNERS',
  INSTANT_CONTROL_OWNERS = 'INSTANT_CONTROL_OWNERS',
  INSTANT_CONTROL_TERMINALS = 'INSTANT_CONTROL_TERMINALS',
  RANDOM_CONTROL_TERMINALS = 'INSTANT_CONTROL_TERMINALS',
  GLC = 'GLC',
  GLC_HISTORY = 'GLC_HISTORY',
  GLC_DETAILS = 'GLC_DETAILS',
  GLC_SEARCH = 'GLC_SEARCH',
  GLC_TERMINALS = 'GLC_TERMINALS',
  APP_VERSION = 'APP_VERSION',
  LOGGED_USER_DETAILS = 'LOGGED_USER_DETAILS',
  SETTINGS = 'SETTINGS',
  OWNERS_CONTROL = 'OWNERS_CONTROL',
  PASSWORD_POLICY = 'PASSWORD_POLICY',
  TERMINALS_WITH_DISPLAY = 'TERMINALS_WITH_DISPLAY',
  TERMINALS_WITH_SEQUENCE = 'TERMINALS_WITH_SEQUENCE',
  CONTROL_HISTORY = 'CONTROL_HISTORY',
  WANTED = 'WANTED',
  WANTED_HISTORY = 'WANTED_HISTORY',
  WANTED_TERMINALS = 'WANTED_TERMINALS',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  ANNOUNCEMENTS_SEARCH = 'ANNOUNCEMENTS_SEARCH',
  ANNOUNCEMENT_DETAILS = 'ANNOUNCEMENT_DETAILS',
  ANNOUNCEMENTS_HISTORY = 'ANNOUNCEMENTS_HISTORY',
  ANNOUNCEMENT_MODS = 'ANNOUNCEMENT_MODS',
  ANNOUNCEMENT_MODES = 'ANNOUNCEMENT_MODES',
  ANNOUNCEMENT_ASSIGNED_OWNERS = 'ANNOUNCEMENT_ASSIGNED_OWNERS',
  LOGOTYPE = 'LOGOTYPE',
  SCHEDULES = 'SCHEDULES',
  SCHEDULES_SEARCH = 'SCHEDULES_SEARCH',
  SCHEDULE_DETAILS = 'SCHEDULE_DETAILS',
  SCHEDULE_TERMINALS = 'SCHEDULE_TERMINALS',
  SCHEDULES_EXCEPTIONS = 'SCHEDULES_EXCEPTIONS',
  SCHEDULE_EXCEPTION_TERMINALS = 'SCHEDULE_EXCEPTION_TERMINALS',
  SCHEDULES_HISTORY = 'SCHEDULES_HISTORY',
  SEQUENCES = 'SEQUENCES',
  SEQUENCES_HISTORY = 'SEQUENCES_HISTORY',
  USERS_LOGIN_HISTORY = 'USERS_LOGIN_HISTORY',
  USER_HISTORY = 'USER_HISTORY',
  USER_PERMISSIONS_HISTORY = 'USER_PERMISSIONS_HISTORY',
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  USER_DATA_PERMISSIONS = 'USER_DATA_PERMISSIONS',
  USER_ACCESS_FLAGS = 'USER_ACCESS_FLAGS',
  USER_ACCESS_SETTINGS = 'USER_ACCESS_SETTINGS',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  MAIL_ACCOUNT = 'MAIL_ACCOUNT',
  AUTOMATION_CONFIG = 'AUTOMATION_CONFIG',
  AUTO_EXPORT_CONFIG = 'AUTO_EXPORT_CONFIG',
  AUTO_EXPORT_STATUS = 'AUTO_EXPORT_STATUS',
  AUTO_EXPORT_PREVIEW = 'AUTO_EXPORT_PREVIEW',
  LICENSE = 'LICENSE',
  DOD_STATUS = 'DOD_STATUS',
  DOD_QUEUE_DETAIL = 'DOD_QUEUE_DETAIL',
  DOD_METRICS = 'DOD_METRICS',
  DOD_HISTORY = 'DOD_HISTORY',
  DOD_CAPABILITIES = 'DOD_CAPABILITIES',
  DOD_OVERVIEW = 'DOD_OVERVIEW',
  DOD_TIMESERIES = 'DOD_TIMESERIES',
  DOD_QUEUES = 'DOD_QUEUES',
  DOD_DLQ = 'DOD_DLQ',
  DOD_RETRIES = 'DOD_RETRIES',
  DOD_WORKER = 'DOD_WORKER',
  DOD_QUEUE_DETAIL_V2 = 'DOD_QUEUE_DETAIL_V2',
  DOD_DLQ_SUMMARY = 'DOD_DLQ_SUMMARY',
  DOD_HISTORY_V2 = 'DOD_HISTORY_V2',
  DOD_PROMQL = 'DOD_PROMQL',
}

export enum DateFormat {
  FULL = 'yyyy/MM/dd HH:mm:ss',
  DATE = 'yyyy/MM/dd',
  TIME = 'HH:mm:ss',
  TIME_SHORT = 'HH:mm',
}

export enum HistoryActionEnum {
  ZABLOKOWANO = 'ZABLOKOWANO',
  ODBLOKOWANO = 'ODBLOKOWANO',
  ZWROCONO = 'ZWROCONO',
  WYDANO = 'WYDANO',
  ZARCHIWIZOWANO = 'ZARCHIWIZOWANO',
  PRZYWROCONO = 'PRZYWROCONO',
  DODANO = 'DODANO',
  ZEDYTOWANO = 'ZEDYTOWANO',
  USUNIETO = 'USUNIETO',
  ZALOGOWANO = 'ZALOGOWANO',
  WYLOGOWANO = 'WYLOGOWANO',
}

export enum GroupHistoryActionEnum {
  ZARCHIWIZOWANO = 'ZARCHIWIZOWANO',
  PRZYWROCONO = 'PRZYWROCONO',
  DODANO = 'DODANO',
  ZEDYTOWANO = 'ZEDYTOWANO',
}
